<style scoped lang="scss">
.Withdrawal-content-div {
    height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    padding: 1.5rem;
}

.Withdrawal_data-div {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
    }
}

.Withdrawal-header {
    margin-bottom: 1.5rem;
    font-weight: 600;
    font-size: 1.1rem;
    color: #1a1a1a;
    position: relative;
    padding-left: 1.25rem;
    
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 1.1rem;
        background: linear-gradient(to bottom, #6B46C1, #805AD5);
        border-radius: 2px;
    }
    
    .el-input {
        .el-input__inner {
            border-radius: 8px;
            border-color: rgba(107, 70, 193, 0.2);
            transition: all 0.2s ease;
            
            &:hover, &:focus {
                border-color: #6B46C1;
                box-shadow: 0 0 0 2px rgba(107, 70, 193, 0.1);
            }
        }
    }
    
    .el-button {
        transition: all 0.2s ease;
        
        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
    }
}

:deep(.Withdrawal_data) {
    --el-table-border-color: rgba(107, 70, 193, 0.1);
    --el-table-header-bg-color: #f8fafc;
    border-radius: 12px;
    
    th {
        background: #f8fafc;
        font-weight: 600;
        color: #1a1a1a;
        font-size: 0.9rem;
        padding: 0.75rem;
        border-bottom: 2px solid rgba(107, 70, 193, 0.1);
        position: relative;
        
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: linear-gradient(to right, rgba(107, 70, 193, 0.1), rgba(107, 70, 193, 0.2), rgba(107, 70, 193, 0.1));
        }
    }
    
    td {
        color: #1a1a1a;
        font-size: 0.9rem;
        padding: 0.75rem;
        position: relative;
        transition: all 0.2s ease;
        
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: rgba(107, 70, 193, 0.05);
        }
    }
    
    tr {
        transition: all 0.2s ease;
        position: relative;
        
        &:hover {
            background: rgba(107, 70, 193, 0.02);
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            z-index: 1;
            
            td {
                color: #6B46C1;
                
                &::after {
                    background: linear-gradient(to right, rgba(107, 70, 193, 0.1), rgba(107, 70, 193, 0.2), rgba(107, 70, 193, 0.1));
                }
            }
        }
        
        &:nth-child(even) {
            background: rgba(107, 70, 193, 0.01);
        }
    }
    
    .el-button {
        padding: 0.5rem 1rem;
        font-size: 0.85rem;
        border-radius: 8px;
        transition: all 0.2s ease;
        position: relative;
        overflow: hidden;
        
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
            transform: translateX(-100%);
            transition: transform 0.3s ease;
        }
        
        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            
            &::before {
                transform: translateX(100%);
            }
        }
    }
    
    .liu-text-success {
        color: #10b981;
        font-weight: 500;
        font-size: 0.9rem;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
            color: #059669;
            transform: translateY(-1px);
        }
    }
}

.pagination {
    margin: 1.5rem auto 0;
    padding: 1rem;
    background: rgba(107, 70, 193, 0.02);
    border-radius: 12px;
    
    :deep(.el-pagination__total),
    :deep(.el-pagination__sizes) {
        margin-right: 1rem;
    }
    
    :deep(.btn-prev),
    :deep(.btn-next),
    :deep(.el-pager li) {
        background: white;
        border-radius: 6px;
        transition: all 0.2s ease;
        
        &:hover {
            color: #6B46C1;
        }
        
        &.is-active {
            background: #6B46C1;
            color: white;
        }
    }
}

:deep(.el-dialog) {
    border-radius: 16px;
    overflow: hidden;
    
    .el-dialog__header {
        background: linear-gradient(135deg, #6B46C1 0%, #805AD5 100%);
        margin: 0;
        padding: 1.25rem 1.5rem;
        
        .el-dialog__title {
            color: white;
            font-size: 1.1rem;
            font-weight: 600;
        }
        
        .el-dialog__headerbtn {
            top: 1.25rem;
            right: 1.5rem;
            
            .el-dialog__close {
                color: rgba(255, 255, 255, 0.9);
                font-size: 1.25rem;
                
                &:hover {
                    color: white;
                    transform: rotate(90deg);
                }
            }
        }
    }
    
    .el-dialog__body {
        padding: 1.5rem;
    }
    
    .el-dialog__footer {
        padding: 1rem 1.5rem;
        border-top: 1px solid rgba(107, 70, 193, 0.1);
        
        .el-button {
            padding: 0.5rem 1.25rem;
            font-size: 0.9rem;
            border-radius: 8px;
            transition: all 0.2s ease;
            
            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }
        }
    }
}

:deep(.el-tabs) {
    .el-tabs__header {
        margin-bottom: 1.5rem;
        
        .el-tabs__nav-wrap::after {
            height: 1px;
            background: rgba(107, 70, 193, 0.1);
        }
        
        .el-tabs__item {
            font-size: 0.95rem;
            font-weight: 500;
            color: #64748b;
            transition: all 0.2s ease;
            
            &.is-active {
                color: #6B46C1;
                font-weight: 600;
            }
            
            &:hover {
                color: #6B46C1;
            }
        }
    }
}

// 移动端适配
@media screen and (max-width: 768px) {
    .Withdrawal-content-div {
        padding: 0;
        margin: 0;
    }
    
    .Withdrawal_data-div {
        width: 95vw !important;
        margin: 1rem;
        padding-bottom: 10rem;
    }
    
    .Withdrawal-header {
        margin-bottom: 1rem;
        
        .el-input {
            width: 100% !important;
            margin-left: 0 !important;
            margin-bottom: 0.5rem;
        }
        
        .el-button {
            width: 100%;
            margin-left: 0 !important;
        }
    }
    
    :deep(.Withdrawal_data) {
        th, td {
            padding: 0.5rem;
        }
    }
}

// PC端适配
@media screen and (min-width: 769px) {
    .Withdrawal_data-div {
        margin-left: 2rem !important;
        margin-top: 2rem !important;
    }
    
    .Withdrawal_data {
        min-width: 90%;
    }
}
</style>
<template>
    <div class="common-layout">
        <el-container>
            <el-aside style="width: fit-content;">
                <UserHead />
            </el-aside>
            <el-container>
                <el-header style="padding: 0;">
                    <HeadTop />
                </el-header>
                <el-main
                    style="padding-top: 0;height: 100vh;overflow: auto;padding-left: 0;background-color: rgb(242, 242, 242) !important;">
                    <div class="Withdrawal-content-div">
                        <div style="padding-bottom: 3rem;">
                            <div class="Withdrawal_data-div rounded shadow">
                                <div class="Withdrawal-header">
                                    <el-input style="width:180px;margin-left: 10px;" v-model="userList.keyword"
                                        placeholder="邮箱/昵称/uid关键词" width="200" />
                                    <el-button style="margin-left: 10px;" type="primary"
                                        @click="getUserList()">搜索</el-button>
                                </div>
                                <el-table :data="userList.data" class="Withdrawal_data">
                                    <el-table-column prop="uid" label="uid" />
                                    <el-table-column prop="user_email" label="邮箱" />
                                    <el-table-column prop="username" label="昵称" />
                                    <el-table-column prop="higher_uid" label="上级" />
                                    <el-table-column prop="money" label="余额">
                                        <template #default="scope">
                                            <div class="liu-text-success" @click="editMoneyDialog(scope.row)">
                                                {{ scope.row.money }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="150">
                                        <template v-slot="scope">
                                            <div style="display: flex;flex-direction: row;">

                                                <el-button type="primary" @click="editDialog(scope.row)">编辑</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination class="pagination" v-model:current-page="userList.currentPage"
                                    v-model:page-size="userList.pageSize" :page-sizes="[10, 25, 50]" :small="small"
                                    :disabled="disabled" :background="background"
                                    layout="total, sizes, prev, pager, next, jumper" :total="userList.total"
                                    @size-change="getUserList" @current-change="getUserList" />
                            </div>
                        </div>
                        <el-dialog v-model="editMoneyDialogData.show" title="手动充值/扣款" width="40%">
                            <el-tabs v-model="editMoneyDialogData.type" type="card" @tab-click="handleClick">
                                <el-tab-pane label="充值" :name="1"></el-tab-pane>
                                <el-tab-pane label="扣款" :name="2"></el-tab-pane>
                            </el-tabs>
                            <el-form :model="editMoneyDialogData" label-width="120px">
                                <el-form-item label="金额">
                                    <el-input v-model="editMoneyDialogData.money" type="number" />
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input v-model="editMoneyDialogData.remark" />
                                </el-form-item>
                            </el-form>
                            <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="editMoneyDialogData.show = false">取消</el-button>
                                    <el-button type="primary" @click="submitEditMoney">确认</el-button>
                                </span>
                            </template>
                        </el-dialog>
                        <el-dialog v-model="editDialogData.show" title="编辑用户" width="50%">
                            <el-form :model="editDialogData.data" label-width="120px">
                                <el-form-item label="用户ID">
                                    <el-input v-model="editDialogData.data.uid" disabled />
                                </el-form-item>
                                <el-form-item label="用户名">
                                    <el-input v-model="editDialogData.data.username" />
                                </el-form-item>
                                <el-form-item label="邮箱">
                                    <el-input v-model="editDialogData.data.user_email" />
                                </el-form-item>
                                <el-form-item label="上级ID">
                                    <el-input v-model="editDialogData.data.higher_uid" />
                                </el-form-item>
                                <el-form-item label="密码">
                                    <el-input v-model="editDialogData.data.password" placeholder="不修改请留空" />
                                </el-form-item>
                            </el-form>
                            <template #footer>
                                <span class="dialog-footer">
                                    <el-button @click="editDialogData.show = false">取消</el-button>
                                    <el-button type="primary" @click="submitEdit">确认</el-button>
                                </span>
                            </template>
                        </el-dialog>

                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull } from "@/utils/publicMethods"
import { ElMessage, } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            userList: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
                keyword: "",
                data: []
            },
            editDialogData: {
                show: false,
                data: {
                    uid: "",
                    username: "",
                    user_email: "",
                    higher_uid: "",
                    password: "",
                }
            },
            editMoneyDialogData: {
                type: 1,
                show: false,
                uid: "",
                money: 0.00,
                remark: ""
            }
        }
    },
    methods: {
        getUserList() {
            openLoading()
            const data = {
                keyword: this.userList.keyword,
                pageSize: this.userList.pageSize,
                currentPage: this.userList.currentPage
            }
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/userManage/getAllUser', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.userList.data = res.data.data.data
                        this.userList.total = res.data.data.total
                        return
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        editDialog(data) {
            this.editDialogData.data = data;
            this.editDialogData.show = true;
        },
        submitEdit() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/userManage/updateUserInfo', this.editDialogData.data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        this.editDialogData.show = false;
                        this.getUserList();
                        return
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        submitEditMoney() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            };
            const data = {
                type: this.editMoneyDialogData.type,
                uid: this.editMoneyDialogData.uid,
                money: this.editMoneyDialogData.money,
                remark: this.editMoneyDialogData.remark
            }
            axios.post(baseURL + '/adminApi/userManage/updateUserMoney', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                        this.editMoneyDialogData.show = false;
                        this.getUserList();
                        return
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    ElMessage.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        editMoneyDialog(data) {
            this.editMoneyDialogData.uid = data.uid;
            this.editMoneyDialogData.show = true;
        },
        isNull(text) {
            return isNull(text);
        }
    },
    mounted() {
        this.getUserList()
    }
})
</script>
